export default __webpack_public_path__ + "static/media/booking1.56f596ba.png";